import React, { useEffect, useRef, useState } from 'react';
import BreadcrumbComponent from '../../../../../components/Breadcrumb';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { TieredMenu } from 'primereact/tieredmenu';
import { exportExcel, exportPDF } from '../../../../../components/Export';
import bulletinService from './bulletin-service';
import { useToast } from '../../../../../components/Toast';

interface RecordFilter {
    [key: string]: string | boolean | Date; // Adjust types as needed
}

const BulletinList: React.FC = () => {

    const [gridDataSource, setGridDataSource] = useState<any[]>([]);
    const [clientState, setClientState] = useState<any>(null);
    const navigate = useNavigate();
    const { showToast } = useToast();
    const menuRef = useRef<TieredMenu>(null);
    const [isValid, setIsValid] = useState<boolean>(true);
    const [recordFilter, setRecordFilter] = useState<RecordFilter>({
        dateFrom: new Date(),
        dateTo: new Date(),
    });

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await bulletinService.getClientState();
                setClientState(clientStateItem);

            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    useEffect(() => {
        if (clientState) {
            const fetchUserList = async () => {

                if (recordFilter.dateFrom !== null && recordFilter.dateTo !== null) {
                    if (recordFilter.dateFrom > recordFilter.dateTo) {
                        setIsValid(false);
                    } else {
                        setIsValid(true);
                        try {

                            //Add filter
                            recordFilter.facilityCode = clientState.facilityCode;

                            bulletinService.findAll(recordFilter).then((data) => {
                                setGridDataSource(data);
                            });
                        } catch (error) {
                            showToast(clientState.error);
                        }
                    }
                }
            };

            fetchUserList();
        }
    }, [clientState, recordFilter]);

    const actionTemplate = (rowData: any) => {
        function handleEdit(item: any): void {
            navigate('/admin/bulletin-edit', { state: { selectedItem: item } });
        }

        return (
            <div style={{ display: 'flex', gap: '5px' }}>
                <Button
                    label="View"
                    icon="pi pi-eye"
                    className="p-button-info p-button-sm "
                    style={{ padding: '5px 5px', fontSize: '10px' }}
                    onClick={() => handleEdit(rowData)}
                />
            </div>
        );
    }

    const header = () => {

        const formatDate = (date: any): string => {
            if (!date || typeof date === "boolean") return "Invalid Date";
            return new Date(date).toLocaleDateString("en-GB");
        };

        const fileName = `Sample Page ${formatDate(recordFilter.dateFrom)} - ${formatDate(recordFilter.dateTo)}`;

        const exportOptions: any[] = [
            {
                label: "Export to Excel",
                icon: "pi pi-file-excel",
                command: () => exportExcel(fileName),
            },
            {
                label: "Export to PDF",
                icon: "pi pi-file-pdf",
                command: () => exportPDF(fileName),
            },
        ];

        function handleCreate(): void {
            navigate(`/admin/bulletin-edit`);
        }

        return (
            <div>
                <div className="flex justify-content-between">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '.3em' }}>
                        <Button icon="pi pi-ellipsis-v" className="p-button-text p-button-plain" onClick={(e) => menuRef.current?.toggle(e)} />
                    </div>
                    <div>
                        <TieredMenu model={exportOptions} popup ref={menuRef} />
                        <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} />
                    </div>
                </div>
            </div>
        );
    };


    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Bulletin Page</h5>
                    <BreadcrumbComponent />
                </div>

                <div className='card'>
                    {/* Filter Date From and Date To */}
                    {/* <Toolbar start={recordFilterTemplate}></Toolbar> */}
                    <div><br></br></div>
                    <>
                        <DataTable
                            value={gridDataSource}
                            showGridlines
                            scrollable
                            scrollHeight='auto'
                            paginator rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            header={header}
                            sortField='modifiedDate'
                            sortOrder={-1}
                        >
                            <Column
                                header="No."
                                style={{ width: '5%' }}
                                body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                            ></Column>
                            <Column field="memoId" header="Bulletin ID" style={{ width: '10%' }}></Column>
                            <Column field="fullDesc" header="Title"></Column>
                            <Column field="fromDate" header="Start Date" body={(rowData) => new Date(rowData.fromDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })}></Column>
                            <Column field="toDate" header="End Date" body={(rowData) => new Date(rowData.toDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', })}></Column>
                            {/* <Column field="recordStatus" header="Status" body={(rowData) => rowData.recordStatus === '1' ? 'Active' : 'Inactive'}></Column> */}
                            <Column body={actionTemplate} header="Actions" style={{ width: '20%' }} ></Column>
                        </DataTable>
                    </>
                </div>
            </div>
        </div >
    );
};

export default BulletinList;